import { postAuth, putAuth, getAuth, getCSCId, setCSCId, getSessionGuid } from './api'
import { login } from './auth'
import _ from 'lodash'
import {
  GET_RESERVATION_BY_NUMBER_AND_DRIVERS_BIRTHDAY_URL,
  GET_RESERVATION_BY_NUMBER_AND_LICENCE_PLATE_URL,
  UPDATE_RESERVATION_URL,
  CHECKIN_RESERVATION_URL,
  SET_RESERVATION_DRIVERS_URL,
  GET_TERMINAL_INFO_BY_ID_URL,
  GET_UI_CONFIG_URL,
} from '../constants/urls'
import {
  GET_RESERVATION_BY_NUMBER_AND_DRIVERS_BIRTHDAY,
  GET_RESERVATION_BY_NUMBER_AND_DRIVERS_BIRTHDAY_SUCCESS,
  GET_RESERVATION_BY_NUMBER_AND_DRIVERS_BIRTHDAY_FAILURE,
  GET_RESERVATION_BY_NUMBER_AND_LICENCE_PLATE,
  GET_RESERVATION_BY_NUMBER_AND_LICENCE_PLATE_SUCCESS,
  GET_RESERVATION_BY_NUMBER_AND_LICENCE_PLATE_FAILURE,
  UPDATE_RESERVATION,
  UPDATE_RESERVATION_SUCCESS,
  UPDATE_RESERVATION_FAILURE,
  CHECKIN_RESERVATION,
  CHECKIN_RESERVATION_SUCCESS,
  CHECKIN_RESERVATION_FAILURE,
  SET_RES_ID,
  SET_DRIVER1_BIRTH_DATE,
  TRY_GET_RESERVATION_BY_LICENCE_PLATE,
  CLEAR_RESERVATION,
  GET_RESERVATION_ORIGIN_SUCCESS,
  GET_TERMINAL_INFO_BY_ID,
  SET_USER_NOTE,
  GET_UI_CONFIG_SUCCESS,
  SET_TOTAL_PAGES_COUNT,
  SET_CURRENT_PAGE,
  SET_RESERVATION_CHANGE,
} from '../constants/actions'
import { Reservation, CargoUnit, Driver, composeReservation, ReservationChange } from '../types/reservation'
import { UI } from '../constants/ui'
import { setUIForwardAction, setErrorAction } from './ui'
import { Log, Err } from '../utilities/logger'
import { composeTerminal, Terminal } from '../types/terminal'
import { jsonTerminalParse } from '../types/converter'
import {
  USERNOTE_EL_CONNECTION_NEEDED,
  USERNOTE_I_HAVE_DANGEROUS_GOODS,
  USERNOTE_MORE_THAN_ONE_PASSENGER,
  USERNOTE_CHECKIN_BATCH_SERVER,
} from '../constants/userNote'
import { composeUiConfig, UiConfig } from '../types/uiConfig'
import { isReservationELConnectionHide, isELConnectionHideSelector } from '../reducers/terminal'
import { composeDOBYear2To4Digits } from '../components/DateInput'
import { setUserDataStore, USER_INPUT_DATA } from './localStorage'
import { getMode } from '../hooks/mode'
import { MODE } from '../constants/mode'

const SEARCH_WORD_IN_BATCH_MESSAGE = 'BATCH'
const TRAILER = 'TRUCK TRAILER'
const contentType = 'EMPTY'

export interface ReservationRequestLicencePlate {
  resId: number
  regNumber: string
}

const refineReservationDrivers = async (reservation: any) => {
  if (
    reservation &&
    reservation.resId &&
    reservation.drivers &&
    (reservation.drivers.length === 0 ||
      !reservation.drivers[0].id ||
      (reservation.drivers.length === 2 && !reservation.drivers[1].id))
  ) {
    const CSCId = getCSCId()
    const sessionGuId = getSessionGuid()
    if (!CSCId || !sessionGuId) {
      throw new Error(`refine reservation drivers error, id: ${CSCId}, sessionGuId: ${sessionGuId}`)
    }
    const response = await postAuth(SET_RESERVATION_DRIVERS_URL, CSCId, sessionGuId, reservation)
    if (response.data && response.data.drivers) {
      const drivers = _.map(response.data.drivers, (item) => ({ ...item, changed: true }))
      return { ...response.data, drivers }
    }
    return response.data
  } else if (reservation && reservation.resId) {
    return reservation
  }
  if (!reservation || !reservation.resId) {
    return undefined
  }
}

const getEmptyDriver = (cabinCategory: string): Driver => ({
  firstName: '',
  lastName: '',
  birthDate: '',
  gender: '',
  citizenship: '',
  docIssuedCountry: '',
  docType: '',
  docNumber: '',
  docExpirationDate: '',
  scanImage: '',
  changed: true,
  cabinCategory,
  guestId: '',
})

const validateUpdateReservationDriversInfo = (reservation: any, birthDate: string) => {
  const drivers: Driver[] = []
  let addedCorrectDriver = false
  if (reservation.drivers.length === 0) {
    return reservation
  }
  if (reservation.drivers[0].birthDate === birthDate) {
    drivers.push(reservation.drivers[0])
    addedCorrectDriver = true
  } else {
    drivers.push(getEmptyDriver(reservation.drivers[0].cabinCategory))
  }
  if (reservation.drivers[1]) {
    if (reservation.drivers[1].birthDate === birthDate || addedCorrectDriver) {
      drivers.push(reservation.drivers[1])
      addedCorrectDriver = true
    } else {
      drivers.push(getEmptyDriver(reservation.drivers[1].cabinCategory))
    }
  }
  if (!addedCorrectDriver) {
    //set birthday date for first user
    drivers[0].birthDate = birthDate
  }

  return { ...reservation, drivers }
}

export const isTruckTrailer = (reservationChange: Partial<ReservationChange>) => {
  return reservationChange && (reservationChange.cargoType === TRAILER || !reservationChange.cargoType)
}

export const totalPagesCount = (
  reservationChange: ReservationChange,
  isDocumentRequires: boolean,
  isELConnectionHide: boolean,
): number => {
  const mode = getMode()
  const isUserSetNotEmpty = reservationChange.cargoContent !== contentType && +reservationChange.cargoWeight === 0
  const increaseWithTrailer = isTruckTrailer(reservationChange) ? 1 : 0
  const increaseIfUserSetNotEmpty = isUserSetNotEmpty ? 1 : 0
  const increaseIfNotEmpty = +reservationChange.cargoWeight !== 0 ? 1 : 0
  let decreaseIfDocumentRequires = isDocumentRequires ? 0 : 1
  const decreaseIfELConnectionHide = isELConnectionHide ? 1 : 0

  let minPagesCount = 11

  let increaseDriversCount = 0
  if (reservationChange.drivers && reservationChange.drivers.length === 2) {
      if(mode === MODE.MOBILE) {
        increaseDriversCount = 1
      } else {
        increaseDriversCount = 2
      }
      decreaseIfDocumentRequires = 2 * decreaseIfDocumentRequires
  }
  if (mode === MODE.MOBILE) {
    decreaseIfDocumentRequires = 1
  }
  return (
    minPagesCount +
    increaseDriversCount +
    increaseWithTrailer +
    increaseIfUserSetNotEmpty +
    increaseIfNotEmpty -
    decreaseIfDocumentRequires -
    decreaseIfELConnectionHide
  )
}

export const setTotalPagesCountAction: any = (reservationChange: ReservationChange) => async (
  dispatch: any,
  getState: any,
) => {
  const isDocumentRequires = getState().reservation.isDocumentRequires
  const isELConnectionHide = isELConnectionHideSelector(getState())
  dispatch({
    type: SET_TOTAL_PAGES_COUNT,
    payload: totalPagesCount(reservationChange, isDocumentRequires, isELConnectionHide),
  })
}

export const clearCurrentPageAction = () => ({ type: SET_CURRENT_PAGE, payload: 0 })

const isDocumentRequiresCheck = (reservation: Reservation, composedUiConfig: UiConfig) => {
  try {
    return composedUiConfig.documentRequiresLocation.some(
      (item) => item === reservation.route.portFrom || item === reservation.route.portTo,
    )
  } catch (e) {
    Log('set isDocumentRequire error', e)
    return false
  }
}

const getUiConfig = async (id: string, sessionGuId: string) => {
  let responseData = null
  try {
    const response = await getAuth(GET_UI_CONFIG_URL, id, sessionGuId)
    responseData = response.data
  } catch (e) {
    Log('get UI config error', e)
  }
  return composeUiConfig(responseData)
}

const setReservationChange = (reservation: Reservation): ReservationChange => {
  return {
    drivers: _.cloneDeep(reservation.drivers),
    carLicencePlate: reservation.cargoUnit.regNumber,
    trailerRegCountry: reservation.cargoUnit.trailerCountry,
    trailerLicencePlate: reservation.cargoUnit.trailerRegNumber,
    cargoLength: `${reservation.cargoUnit.length}`,
    cargoContent: reservation.content,
    cargoWeight: `${reservation.cargoUnit.cargoWeight}`,
    consignee: reservation.consigneeName,
    countryFrom: reservation.countryFrom,
    countryTo: reservation.countryTo,
    cargoType: reservation.cargoType,
    resId: `${reservation.resId}`,
    driverIndex: 0,
    userNote: '',
  }
}

const getTerminalInfoByID: any = async (reservation: Reservation, CSCId: string, sessionGuId: string) => {
  let result: Terminal | null = null
  const mode = getMode()
  const portShipId = `${reservation.route.portFrom}-${reservation.route.ship}`

  if (mode !== MODE.KIOSK) {
    setCSCId(portShipId)
    const responseTerminalInfo = await getAuth(GET_TERMINAL_INFO_BY_ID_URL + `/${portShipId}`, portShipId, sessionGuId)
    const responseData = jsonTerminalParse(responseTerminalInfo.data)
    result = responseData
  } else {
    const responseTerminalInfo = await getAuth(GET_TERMINAL_INFO_BY_ID_URL + `/${CSCId}`, CSCId, sessionGuId)
    const responseData = jsonTerminalParse(responseTerminalInfo.data)
    result = responseData
  }

  if (mode === MODE.KIOSK && result) {
    try {
      const responseTerminalInfoPortShipId = await getAuth(GET_TERMINAL_INFO_BY_ID_URL + `/${portShipId}`, CSCId, sessionGuId)
      const responsePortShipId = jsonTerminalParse(responseTerminalInfoPortShipId.data)
      if (responsePortShipId) {
        if (!_.isEmpty(responsePortShipId.firstInstruction)) {
          result.firstInstruction = responsePortShipId.firstInstruction
        }
        if (!_.isEmpty(responsePortShipId.secondInstruction)) {
          result.secondInstruction = responsePortShipId.secondInstruction
        }
        if (_.isBoolean(responsePortShipId.allowReprint)) {
          result.allowReprint = responsePortShipId.allowReprint
        }
      }
    } catch (e) {
      Log('get terminal info by Port-Ship Id error', e)
    }
  }

  return composeTerminal(result)
}

export const getReservationByNumberAndDriversBirthday: any = (resId: string, driverBirthDate: string) => async (
  dispatch: any,
) => {
  const request = {
    resId: +resId,
    driverBirthDate: composeDOBYear2To4Digits(driverBirthDate),
    mode: MODE[getMode()],
  }
  try {
    dispatch({ type: SET_RES_ID, payload: request.resId })
    dispatch({ type: GET_RESERVATION_BY_NUMBER_AND_DRIVERS_BIRTHDAY })

    const CSCId = getCSCId()
    if (!CSCId) {
      dispatch({ type: GET_RESERVATION_BY_NUMBER_AND_DRIVERS_BIRTHDAY_FAILURE })
      dispatch(setErrorAction('defaultErrorMessage', 'turnToCheckInCounter'))
      return
    }

    await login(CSCId)

    const sessionGuId = getSessionGuid()
    if (!sessionGuId) {
      dispatch({ type: GET_RESERVATION_BY_NUMBER_AND_DRIVERS_BIRTHDAY_FAILURE })
      dispatch(setErrorAction('defaultErrorMessage', 'turnToCheckInCounter'))
      return
    }

    const uiConfig = await getUiConfig(CSCId, sessionGuId)
    if (!uiConfig) {
      throw new Error('uiConfig error')
    }
    dispatch({ type: GET_UI_CONFIG_SUCCESS, payload: uiConfig })

    const response = await postAuth(GET_RESERVATION_BY_NUMBER_AND_DRIVERS_BIRTHDAY_URL, CSCId, sessionGuId, request)
    if (response.data) {
      dispatch({
        type: GET_RESERVATION_ORIGIN_SUCCESS,
        payload: composeReservation(response.data),
      })
      const reservationWithDrivers = await refineReservationDrivers(response.data)
      const reservation = composeReservation(reservationWithDrivers)
      const reservationChange = setReservationChange(reservation)

      const isDocumentRequires = isDocumentRequiresCheck(reservation, uiConfig)

      dispatch({
        type: GET_RESERVATION_BY_NUMBER_AND_DRIVERS_BIRTHDAY_SUCCESS,
        payload: { reservation, isDocumentRequires },
      })
      dispatch({ type: SET_RESERVATION_CHANGE, payload: reservationChange })

      const terminal = await getTerminalInfoByID(reservation, CSCId, sessionGuId)
      dispatch({
        type: GET_TERMINAL_INFO_BY_ID,
        payload: terminal,
      })

      if (reservation.checkedIn) {
        if (request.driverBirthDate === reservation.drivers[0].birthDate) {
          if (terminal && terminal.allowReprint) {
            if (getMode() === MODE.KIOSK) {
              dispatch(setUIForwardAction(UI.ALREADY_CHECKED_IN))
            } else {
              dispatch(setUIForwardAction(UI.DOWNLOAD_SWB))
            }
          } else {
            dispatch(setErrorAction('alreadyCheckedInMessage', 'turnToCheckInCounter'))
          }
        } else {
          dispatch(setErrorAction('alreadyCheckedInMessage', 'alreadyCheckedInIncorrectDOB', true))
        }
      } else {
        dispatch({
          type: SET_TOTAL_PAGES_COUNT,
          payload: totalPagesCount(
            reservationChange,
            isDocumentRequires,
            isReservationELConnectionHide({ reservation, uiConfig }),
          ),
        })
        dispatch(setUIForwardAction(UI.CONFIRM_LICENCE_PLATE))
      }
    } else {
      dispatch({ type: TRY_GET_RESERVATION_BY_LICENCE_PLATE, payload: { id: request.resId } })
      dispatch(setUIForwardAction(UI.LICENCE_PLATE_AUTH))
    }
  } catch (e) {
    Log('get reservation error', e)
    dispatch({ type: GET_RESERVATION_BY_NUMBER_AND_DRIVERS_BIRTHDAY_FAILURE })
    if (e && e.response && e.response.status && e.response.status >= 400 && e.response.data.message) {
      dispatch(setErrorAction(e.response.data.message || 'defaultErrorMessage', ''))
    } else {
      dispatch(setErrorAction('defaultErrorMessage', 'turnToCheckInCounter'))
    }
  }
}
export const getReservationByNumberAndLicencePlate: any = (regNumber: string) => async (
  dispatch: any,
  getState: any,
) => {
  try {
    dispatch({ type: GET_RESERVATION_BY_NUMBER_AND_LICENCE_PLATE })
    const resId = +getState().reservationChange.resId
    const driverBirthDate = composeDOBYear2To4Digits(getState().reservation.birthDate)
    const uiConfig = getState().reservation.uiConfig
    const request = { resId, regNumber, driverBirthDate }

    const CSCId = getCSCId()
    const sessionGuId = getSessionGuid()
    if (!CSCId || !sessionGuId) {
      Log(`get CSCId or sessionGuId error, CSCId:${CSCId}, sesionGuId: ${sessionGuId}`)
      dispatch({ type: GET_RESERVATION_BY_NUMBER_AND_LICENCE_PLATE_FAILURE })
      dispatch(setErrorAction('defaultErrorMessage', 'turnToCheckInCounter'))
      return
    }

    const response = await postAuth(GET_RESERVATION_BY_NUMBER_AND_LICENCE_PLATE_URL, CSCId, sessionGuId, request)
    if (response.data) {
      const reservation = composeReservation(response.data)
      dispatch({
        type: GET_RESERVATION_ORIGIN_SUCCESS,
        payload: reservation,
      })
      const reservationWithoutDriversInfo = validateUpdateReservationDriversInfo(reservation, driverBirthDate)
      const reservationChange = setReservationChange(reservationWithoutDriversInfo)

      const isDocumentRequires = isDocumentRequiresCheck(reservation, uiConfig)

      dispatch({
        type: GET_RESERVATION_BY_NUMBER_AND_LICENCE_PLATE_SUCCESS,
        payload: { reservationWithoutDriversInfo, isDocumentRequires },
      })
      dispatch({ type: SET_RESERVATION_CHANGE, payload: reservationChange })

      dispatch(clearCurrentPageAction())

      const terminal = await getTerminalInfoByID(reservation, CSCId, sessionGuId)
      dispatch({
        type: GET_TERMINAL_INFO_BY_ID,
        payload: terminal,
      })

      if (reservation.checkedIn) {
        if (terminal.allowReprint) {
          if (getMode() === MODE.KIOSK) {
            dispatch(setUIForwardAction(UI.ALREADY_CHECKED_IN))
          } else {
            dispatch(setUIForwardAction(UI.DOWNLOAD_SWB))
          }
        } else {
          dispatch(setErrorAction('alreadyCheckedInMessage', 'turnToCheckInCounter'))
        }
      } else {
        dispatch({
          type: SET_TOTAL_PAGES_COUNT,
          payload: totalPagesCount(
            reservationChange,
            isDocumentRequires,
            isReservationELConnectionHide({ reservation, uiConfig }),
          ),
        })
        dispatch(setUIForwardAction(UI.CONFIRM_RESERVATION))
      }
    } else {
      dispatch({ type: GET_RESERVATION_BY_NUMBER_AND_LICENCE_PLATE_FAILURE })
      dispatch(setErrorAction('licencePlateNotFound', ''))
    }
  } catch (e) {
    Log('get reservation error', e)
    dispatch({ type: GET_RESERVATION_BY_NUMBER_AND_LICENCE_PLATE_FAILURE })
    if (e && e.response && e.response.status && e.response.status >= 400) {
      dispatch(setErrorAction((e.response.data.message && e.response.data.message) || 'defaultErrorMessage', ''))
    } else {
      dispatch(setErrorAction('defaultErrorMessage', 'turnToCheckInCounter'))
    }
  }
}

const updateReservation: any = async (reservation: any, payloadChange: any, CSCId: string, sessionGuId: string) => {
  const driverOne: Driver = {
    ...reservation.drivers[0],
    id: payloadChange.drivers[0].id,
    firstName: payloadChange.drivers[0].firstName,
    lastName: payloadChange.drivers[0].lastName,
    citizenship: payloadChange.drivers[0].citizenship,
    birthDate: payloadChange.drivers[0].birthDate,
    gender: payloadChange.drivers[0].gender,
    docType: payloadChange.drivers[0].docType,
    docExpirationDate: payloadChange.drivers[0].docExpirationDate,
    docIssuedCountry: payloadChange.drivers[0].docIssuedCountry,
    docNumber: payloadChange.drivers[0].docNumber,
  }
  let driverTwo = undefined
  if (reservation.drivers.length === 2) {
    driverTwo = {
      ...reservation.drivers[1],
      id: payloadChange.drivers[1].id,
      firstName: payloadChange.drivers[1].firstName,
      lastName: payloadChange.drivers[1].lastName,
      citizenship: payloadChange.drivers[1].citizenship,
      birthDate: payloadChange.drivers[1].birthDate,
      gender: payloadChange.drivers[1].gender,
      docType: payloadChange.drivers[1].docType,
      docExpirationDate: payloadChange.drivers[1].docExpirationDate,
      docIssuedCountry: payloadChange.drivers[1].docIssuedCountry,
      docNumber: payloadChange.drivers[1].docNumber,
    }
  }

  const driversIsChanged =
    !_.isEqual(driverOne, reservation.drivers[0]) || (driverTwo && !_.isEqual(driverTwo, reservation.drivers[1]))
  const cargoUnit: CargoUnit = {
    ...reservation.cargoUnit,
    regNumber: payloadChange.carLicencePlate,
    trailerCountry: payloadChange.trailerRegCountry,
    trailerRegNumber: payloadChange.trailerLicencePlate,
    length: payloadChange.cargoLength,
    cargoWeight: payloadChange.cargoWeight,
  }
  const payload: Reservation = {
    ...reservation,
    drivers: driverTwo
      ? [
          { ...driverOne, changed: driverOne.changed || driversIsChanged },
          { ...driverTwo, changed: driverTwo.changed || driversIsChanged },
        ]
      : [{ ...driverOne, changed: driverOne.changed || driversIsChanged }],
    cargoUnit,
    content: payloadChange.cargoContent,
    consigneeName: payloadChange.consignee,
    countryFrom: payloadChange.countryFrom,
    countryTo: payloadChange.countryTo,
    driverIndex: payloadChange.driverIndex,
    userNote: payloadChange.userNote,
  }
  const response = await putAuth(UPDATE_RESERVATION_URL, CSCId, sessionGuId, payload)
  return response.data
}

export const updateReservationAndGoConfirmReservationInfoAction: any = () => async (dispatch: any, getState: any) => {
  try {
    dispatch({ type: UPDATE_RESERVATION })
    const reservation = getState().reservation.reservation
    const payloadChange = getState().reservationChange

    const CSCId = getCSCId()
    const sessionGuId = getSessionGuid()
    if (!CSCId || !sessionGuId) {
      Log(`get CSCId or sessionGuId error, CSCId:${CSCId}, sesionGuId: ${sessionGuId}`)
      dispatch(setErrorAction('defaultErrorMessage', 'turnToCheckInCounter'))
      dispatch({ type: UPDATE_RESERVATION_FAILURE })
      return
    }

    const response = await updateReservation(reservation, payloadChange, CSCId, sessionGuId)
    if (response) {
      const reservation = composeReservation(response)

      let newLocalStorageData: {[index: string]: string} = {
        [USER_INPUT_DATA.DRIVER_FIRST_NAME]: _.get(reservation, 'drivers[0].firstName', ''),
        [USER_INPUT_DATA.DRIVER_LAST_NAME]: _.get(reservation, 'drivers[0].lastName', ''),
        [USER_INPUT_DATA.DRIVER_CITIZENSHIP]: _.get(reservation, 'drivers[0].citizenship', ''),
        [USER_INPUT_DATA.DRIVER_DATE_OF_BIRTH]: _.get(reservation, 'drivers[0].birthDate', ''),
        [USER_INPUT_DATA.DRIVER_GENDER]: _.get(reservation, 'drivers[0].gender', ''),
        [USER_INPUT_DATA.DRIVER_DOCUMENT_NUMBER]: _.get(reservation, 'drivers[0].docNumber', ''),
      }

      if (!_.isEmpty(reservation.drivers[1])) {
        newLocalStorageData[USER_INPUT_DATA.DRIVER2_FIRST_NAME] = _.get(reservation, 'drivers[1].firstName', '')
        newLocalStorageData[USER_INPUT_DATA.DRIVER2_LAST_NAME] = _.get(reservation, 'drivers[1].lastName', '')
        newLocalStorageData[USER_INPUT_DATA.DRIVER2_CITIZENSHIP] = _.get(reservation, 'drivers[1].citizenship', '')
        newLocalStorageData[USER_INPUT_DATA.DRIVER2_DATE_OF_BIRTH] = _.get(reservation, 'drivers[1].birthDate', '')
        newLocalStorageData[USER_INPUT_DATA.DRIVER2_GENDER] = _.get(reservation, 'drivers[1].gender', '')
        newLocalStorageData[USER_INPUT_DATA.DRIVER2_DOCUMENT_NUMBER] = _.get(reservation, 'drivers[1].docNumber', '')
      }

      setUserDataStore(newLocalStorageData)

      dispatch({ type: UPDATE_RESERVATION_SUCCESS, payload: reservation })
      dispatch(setUIForwardAction(UI.CONFIRM_RESERVATION_INFO))
    } else {
      dispatch({ type: UPDATE_RESERVATION_FAILURE })
      dispatch(setUIForwardAction(UI.ERROR))
    }
  } catch (e) {
    Log('update reservation and go confirm reservation info error', e)
    dispatch(setErrorAction('defaultErrorMessage', 'turnToCheckInCounter'))
    dispatch({ type: UPDATE_RESERVATION_FAILURE })
  }
}

export const updateReservationAndGoHomeAction: any = (userNote: string) => async (dispatch: any, getState: any) => {
  try {
    dispatch({ type: UPDATE_RESERVATION })
    dispatch({ type: SET_USER_NOTE, payload: userNote })
    const reservation = getState().reservation.reservation
    const payloadChange = getState().reservationChange

    const CSCId = getCSCId()
    const sessionGuId = getSessionGuid()
    if (!CSCId || !sessionGuId) {
      Log(`get CSCId or sessionGuId error, CSCId:${CSCId}, sesionGuId: ${sessionGuId}`)
      dispatch(setErrorAction('defaultErrorMessage', 'turnToCheckInCounter'))
      dispatch({ type: UPDATE_RESERVATION_FAILURE })
      return
    }

    const response = await updateReservation(reservation, payloadChange, CSCId, sessionGuId)
    if (response) {
      const reservation = composeReservation(response)
      dispatch({ type: UPDATE_RESERVATION_SUCCESS, payload: reservation })
      switch (userNote) {
        case USERNOTE_EL_CONNECTION_NEEDED:
          dispatch(setErrorAction('messageTitleElConnection', 'messageElConnection'))
          break
        case USERNOTE_I_HAVE_DANGEROUS_GOODS:
          dispatch(setErrorAction('messageTitleDangerousGoods', 'messageDangerousGoods'))
          break
        case USERNOTE_MORE_THAN_ONE_PASSENGER:
          dispatch(setErrorAction('messageTitleMoreThanOnePassenger', 'messageMoreThanOnePassenger'))
          break
        case USERNOTE_CHECKIN_BATCH_SERVER:
          dispatch(setErrorAction('messageTitleResLockedByBatchServer', 'messageResLockedByBatchServer'))
          break
        default:
          dispatch(setErrorAction('makeCheckinAtCounterDefault', 'weSaveAllInformationDefault'))
      }
    } else {
      dispatch({ type: UPDATE_RESERVATION_FAILURE })
      dispatch(setUIForwardAction(UI.ERROR))
    }
  } catch (e) {
    Log('update reservation and go home error', e)
    dispatch(setErrorAction('defaultErrorMessage', 'turnToCheckInCounter'))
    dispatch({ type: UPDATE_RESERVATION_FAILURE })
  }
}

const delay = (timeDelay: number) => new Promise((resolve: any) => setTimeout(() => resolve(), timeDelay))

export const checkinReservation: any = (resId: number) => async (dispatch: any, getState: any) => {
  try {
    dispatch({ type: CHECKIN_RESERVATION })
    const timeOfBatchDelay = getState().reservation.uiConfig.batchProcessBlockingDelay

    const CSCId = getCSCId()
    const sessionGuId = getSessionGuid()
    if (!CSCId || !sessionGuId) {
      Log(`get CSCId or sessionGuId error, CSCId:${CSCId}, sessionGuId: ${sessionGuId}`)
      dispatch({ type: CHECKIN_RESERVATION_FAILURE })
      dispatch(setErrorAction('defaultErrorMessage', 'turnToCheckInCounter'))
      return
    }
    
    let response
    try {
      response = await postAuth(CHECKIN_RESERVATION_URL, CSCId, sessionGuId, { resId })
    } catch (e) {
      if (
        e.response.data &&
        e.response.data.message &&
        e.response.data.message.includes(SEARCH_WORD_IN_BATCH_MESSAGE)
      ) {
        Log('Batch server lock res first time', e)
        await delay(timeOfBatchDelay)
        response = await postAuth(CHECKIN_RESERVATION_URL, CSCId, sessionGuId, { resId })
      } else {
        throw e
      }
    }
    if (response && response.data) {
      const reservation = composeReservation(response.data)
      dispatch({ type: CHECKIN_RESERVATION_SUCCESS, payload: reservation })
    } else {
      dispatch({ type: CHECKIN_RESERVATION_FAILURE })
      dispatch(setUIForwardAction(UI.ERROR))
    }
  } catch (e) {
    if (e.response.data && e.response.data.message && e.response.data.message.includes(SEARCH_WORD_IN_BATCH_MESSAGE)) {
      Log('Batch server lock res 2 times', e)
      dispatch(updateReservationAndGoHomeAction(USERNOTE_CHECKIN_BATCH_SERVER))
    } else {
      Log('checkin reservation error', e)
      dispatch({ type: CHECKIN_RESERVATION_FAILURE })
      dispatch(setErrorAction('defaultErrorMessage', 'turnToCheckInCounter'))
    }
  }
}
export const clearReservationAction: any = () => async (dispatch: any) => {
  try {
    dispatch({ type: CLEAR_RESERVATION })
  } catch (e) {
    Err('clear reservation error', e)
  }
}
export const setDriver1BirthDateAction = (birthDate: string) => ({
  type: SET_DRIVER1_BIRTH_DATE,
  payload: birthDate,
})
